import { type ReactNode } from 'react';
import { useCurrentUser } from '../hooks/useCurrentUser';

type Environment = 'production' | 'development' | 'preview';

interface Props {
  environments?: Environment[];
  children: ReactNode | ReactNode[];
  isVisible?: boolean;
  /** Accepted so callers can satisfy the root-className convention on this non-DOM wrapper; not applied by AdminOnly itself. */
  className?: string;
}

const AdminOnly = ({
  children,
  environments = ['production', 'development', 'preview'],
  isVisible = true,
}: Props) => {
  const { isAdmin } = useCurrentUser();

  const isInEnvironment = environments?.includes(process.env.NEXT_PUBLIC_VERCEL_ENV as Environment);

  return isAdmin && isInEnvironment && isVisible ? children : null;
};

export default AdminOnly;
